import { render, staticRenderFns } from "./orderReturnHandle.vue?vue&type=template&id=7f82f2e6&scoped=true&"
import script from "./orderReturnHandle.vue?vue&type=script&lang=js&"
export * from "./orderReturnHandle.vue?vue&type=script&lang=js&"
import style0 from "./orderReturnHandle.vue?vue&type=style&index=0&id=7f82f2e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f82f2e6",
  null
  
)

export default component.exports